import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { showNonMembersPopup } from "../contexts/NonMembersPopupContext";
import { ROUTES } from "../App";
import { useRef } from "react";

const RestrictedRoute = ({ allowedRoles = [] }) => {
    const { currentUser, loading } = useUser();
    const location = useLocation();
    const popupShown = useRef(false);

    if (loading) return null;

    // 🔐 Not logged in → redirect with redirect param
    if (!currentUser) {
        const redirectPath =
            location.pathname + location.search + location.hash;

        return (
            <Navigate
                to={`${ROUTES.SIGN_IN}?redirect=${encodeURIComponent(
                    redirectPath
                )}`}
                replace
            />
        );
    }

    const userRole = currentUser?.role || "Free";

    // ❌ Role not allowed
    if (!allowedRoles.includes(userRole)) {

        if (!popupShown.current) {
            popupShown.current = true;
            showNonMembersPopup();
        }

        return <Navigate to={ROUTES.VIP} replace />;
    }

    // ✅ Allowed
    return <Outlet />;
};

export default RestrictedRoute;